import React from 'react'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js'
import './Home.css'
import img1 from './../../Photo/Quiz.png'
import img3 from './../../Photo/calculator.png'
import img2 from './../../Photo/bmicalculator.png'
import img4 from './../../Photo/Emoji.jpg'
import img5 from './../../Photo/DailyExpenses.png'
import img6 from './../../Photo/stopwatch.png'
import img7 from './../../Photo/Shop.jpg'
import { NavLink } from 'react-router-dom';


const Home = () => {
  return (
    <>
      <div className="container-fluid">

        <div className="row firstrow fixed-top ">
          <div className="col">
            <h1><strong><i>BASIC REACT PROJECTS</i></strong></h1>
            {/* <i><h5>-by Samanvya </h5></i> */}
          </div>
        </div>

        <div className="row mainn">

          <div className="col-2 srowfcol fixed-top  sideb one">

            <nav id="sidebarMenu" class="collapse d-lg-block sidebar collapse ">
              <div className="list-group list-group-flush mx-2 mt-1">
                <div className="card cardnew bg-transparent border-0" >
                  <h5 className='card-text-home'>REACT</h5>
                  <p>React is a JavaScript library for building user interfaces.</p>
                  <p>React is created by Facebook.</p>
                  <p>React is a tool for building the UI components.</p>
                  <p>React creates VIRTUAL DOM in memory.</p>
                  <p>Here are some of basic Examples -</p>
                </div>
              </div>
            </nav>
          </div>
          <div className="col-10 srowscol container offset-sm-2 two" data-bs-spy="scroll">

            <div className='row'>


              <div className="card cardname bg-transparent border-0" >
                <img className="card-img-top citp" src={img1} alt="Card" />
                <div className="card-img-overlay">
                  <h4 className="card-title card-title-home">Quiz</h4>
                  <NavLink to="/quiz" className="btn btn-warning btnun">Open</NavLink>
                </div>
              </div>


              <div className="card cardname  bg-transparent border-0" >
                <img className="card-img-top citp" src={img2} alt="Card" />
                <div className="card-img-overlay">
                  <h4 className="card-title card-title-home">BMI Calculator</h4>
                  <NavLink to="/bmi" className="btn btn-warning btnun">Open</NavLink>
                </div>
              </div>

            </div>


            <div className='row'>


              <div className="card cardname  bg-transparent border-0" >
                <img className="card-img-top citp" src={img3} alt="Card" />
                <div className="card-img-overlay">
                  <h4 className="card-title card-title-home">Calculator</h4>
                  <NavLink to="/calc" className="btn btn-warning btnun">Open</NavLink>
                </div>
              </div>


              <div className="card cardname bg-transparent border-0" >
                <img className="card-img-top citp" src={img7} alt="Card" />
                <div className="card-img-overlay">
                  <h4 className="card-title card-title-home">Shopping</h4>
                  <NavLink to="/shopping" className="btn btn-warning btnun">Open</NavLink>
                </div>
              </div>

            </div>

            <div className='row'>

              <div className="card cardname bg-transparent border-0" >
                <img className="card-img-top citp" src={img5} alt="Card" />
                <div className="card-img-overlay">
                  <h4 className="card-title card-title-home">Daily Expenses</h4>
                  <NavLink to="/daily" className="btn btn-warning btnun">Open</NavLink>
                </div>
              </div>
 
              <div className="card cardname bg-transparent border-0" >
                <img className="card-img-top citp" src={img4} alt="Card" />
                <div className="card-img-overlay">
                  <h4 className="card-title card-title-home">Emoji Search</h4>
                  <NavLink to="/emoji" className="btn btn-warning btnun">Open</NavLink>
                </div>
              </div>

            </div>

            <div className='row'>


            <div className="card cardname bg-transparent border-0" >
                <img className="card-img-top citp" src={img6} alt="Card" />
                <div className="card-img-overlay">
                  <h4 className="card-title card-title-home">Stop Watch</h4>
                  <NavLink to="/stopwatch" className="btn btn-warning btnun">Open</NavLink>
                </div>
              </div>


            </div>

          </div>
        </div>
      </div>
    </>
  )
}

export default Home;